module.exports = __webpack_public_path__ + "img/477.73ab02a9.jpg";